var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_FlowTemplatesMessage_list_title"),
      pad: "0",
      addBtn: _vm.hasBtn("add-admin-template-message"),
      filterable: "",
    },
    on: {
      new: _vm.toNew,
      filter: function (val) {
        _vm.filterPageData = val
      },
    },
    scopedSlots: _vm._u([
      {
        key: "top-selection",
        fn: function (ref) {
          var filter = ref.filter
          return [
            _c("Selections2", {
              attrs: { objects: _vm.filterObjects, "small-chip": "" },
              on: {
                filter: function ($event) {
                  filter()
                  _vm.toFilter(filter)
                },
                update: function (prop, value, selected) {
                  _vm.$fliterValue(_vm.filterObjects, prop, value, selected)
                },
                reset: function (apply) {
                  _vm.$fliterValue(_vm.filterObjects, null, null)
                  if (apply) {
                    filter()
                    _vm.toFilter(filter)
                  }
                },
              },
            }),
          ]
        },
      },
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Tabler", {
              attrs: {
                headers: _vm.headers,
                items: _vm.desserts,
                showSelect: _vm.showSelect,
                totalCount: _vm.totalCount,
                "filter-page-data": _vm.filterPageData,
                height: _vm.$vuetify.breakpoint.height - 275 - 48,
              },
              on: {
                change: function (page, perpage, callback, data) {
                  _vm.getList(data, page, perpage, callback)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "item.name",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "table-title text--primary",
                          attrs: {
                            title: _vm.$getCommonLangValue(
                              item.flow_template_name
                            ),
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$getCommonLangValue(item.flow_template_name)
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "item.object",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "table-title text--primary",
                          attrs: {
                            title: _vm.$getCommonLangValue(
                              item.send_object_name
                            ),
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$getCommonLangValue(item.send_object_name)
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "item.type",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "table-title text--primary",
                          attrs: {
                            title: _vm.$getCommonLangValue(
                              item.messate_type_name
                            ),
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$getCommonLangValue(item.messate_type_name)
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "item.status",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("StatusChip", {
                        attrs: { icon: "", "show-icon": false },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "status",
                              fn: function () {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          item.operating_status_name
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ]
                  },
                },
                {
                  key: "item.action",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("tableListTools", {
                        attrs: {
                          uuid: item.uuid,
                          viewBtn: _vm.hasBtn("view-admin-template-message"),
                          delBtn: _vm.hasBtn("delete-admin-template-message"),
                          editText:
                            "label_essweb_list_components_tools_editBtnLabel",
                          editBtn: _vm.hasBtn("edit-admin-template-message"),
                          title: _vm.$t(
                            "label_essweb_FlowTemplatesMessage_list_title"
                          ),
                        },
                        on: {
                          delete: _vm.toDelete,
                          edit: _vm.toEdit,
                          view: _vm.toView,
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return undefined
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("newMessageConfig", {
              attrs: { show: _vm.showNewConfig },
              on: {
                close: function ($event) {
                  _vm.showNewConfig = false
                },
                new: _vm.onNew,
              },
            }),
            _c("editMessageConfig", {
              attrs: { show: _vm.showEditConfig, curUuid: _vm.curUuid },
              on: {
                close: function ($event) {
                  _vm.showEditConfig = false
                  _vm.curUuid = null
                },
                save: _vm.onSave,
              },
            }),
            _c("viewMessageConfig", {
              attrs: { show: _vm.showViewConfig, curUuid: _vm.curViewUuid },
              on: {
                close: function ($event) {
                  _vm.showViewConfig = false
                  _vm.curViewUuid = null
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }